import { FCC } from "types";

import { BlueSidemenuBlob } from "@/components/Layout/BlueSidemenuBlob/BlueSidemenuBlob";
import { Divider } from "@/components/Layout/Divider";
import { CollapsibleLanguageMenu } from "@/components/Layout/Footer/CollapsibleLanguageMenu";
import { CollapsibleLinkMenu } from "@/components/Layout/Footer/CollapsibleLinkMenu";
import { SupportLinkItem } from "@/components/Layout/Footer/SupportLinkItem";
import { useCustomerData } from "@/components/Onboarding/Steps/PersonalDetails/useCustomerState";
import { getCurrentVersion } from "@/utils/versionCheck";

import { CustomerInfo } from "./CustomerInfo";

export const Sidemenu: FCC = ({ children }) => {
  const version = getCurrentVersion();
  const { customerData } = useCustomerData();

  return (
    <div className="absolute bottom-0 left-0 h-[70vh] max-h-[756px] w-[474px] pb-10 pt-32">
      <BlueSidemenuBlob />
      <nav
        className="fixed bottom-0 left-0 z-30 ml-10 flex h-[inherit] w-44 flex-col justify-between gap-8 pt-36"
        id="menu-items"
      >
        {children}
        <div className="mt-auto flex flex-col gap-4">
          <div>
            <CustomerInfo
              version={version}
              customerNumber={customerData?.customerId}
            />
            <Divider fading />
          </div>
          <div className="mb-10 flex flex-row items-center gap-4">
            <CollapsibleLanguageMenu />
            <SupportLinkItem />
            <CollapsibleLinkMenu />
          </div>
        </div>
      </nav>
    </div>
  );
};
